<template>
  <view class="tw-circle-back" @click="handleBack">
    <i class="tripwise_outline icon-arrowdn_outline"></i>
  </view>
</template>

<script>
export default {
  name: 'index',
  methods: {
    handleBack() {
      this.$emit('back');
    },
  },
};
</script>

<style scoped lang="less" scoped>
.tw-circle-back {
  width: 64rpx;
  height: 64rpx;
  line-height: 64rpx;
  text-align: center;
  background: #fff;
  border-radius: 100%;
  transform: rotate(90deg);
  box-shadow: 4px -2px 12px -2px rgba(51, 65, 84, 0.1716);
}
</style>
